import { split as split_1, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { exists } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { item } from "../fable_modules/fable-library-js.4.24.0/Array.js";

function requiredString(str, minLength, maxLength) {
    if (!isNullOrWhiteSpace(str) && (str.length >= minLength)) {
        return str.length <= maxLength;
    }
    else {
        return false;
    }
}

function requiredInt16(i) {
    if (i >= 0) {
        return i <= 32767;
    }
    else {
        return false;
    }
}

export const containsSpace = (str) => exists((char) => (char === " "), str.split(""));

/**
 * Helper function for validating emails
 */
export function email(x) {
    const trimmed = x.trim();
    const l = requiredString(trimmed, 6, 256);
    const at = trimmed.indexOf("@") >= 0;
    const dot = trimmed.indexOf(".") >= 0;
    const split = split_1(trimmed, ["@"], undefined, 0);
    if (split.length !== 2) {
        return false;
    }
    else {
        const before = item(0, split);
        const after = item(1, split);
        const beforeValid = (before.length > 0) && !containsSpace(before);
        if (((((l && at) && dot) && ((after.length > 2) && !containsSpace(after))) && beforeValid) && (after.indexOf(".") >= 0)) {
            return !(((trimmed.indexOf(",") >= 0) ? true : (trimmed.indexOf("\'") >= 0)) ? true : (trimmed.indexOf("\\") >= 0));
        }
        else {
            return false;
        }
    }
}

export function password(x) {
    return x.length >= 8;
}

export function name(str) {
    return requiredString(str, 1, 50);
}

export function phone(str) {
    return requiredString(str, 1, 50);
}

